import React from 'react';

export const AccountingLogTitle: React.FC = () => <>Buchungsjournal</>;

export default AccountingLogTitle;
